import React from 'react';
import { rotuloCancelamentoUc } from '../../src/lib/dataCancelamentoUc';

/**
 * Data de cancelamento ao lado do selo "Cancelada" (#6005). Não renderiza nada
 * quando a UC não está cancelada. Data estimada do histórico leva "(estimada)" e a
 * explicação no `title` — para não parecer tão certa quanto a registrada na hora.
 */
const DataCancelamentoUc: React.FC<{
    uc: { situacao: string | null | undefined; cancelada_em?: string | null; cancelada_em_origem?: string | null };
    className?: string;
}> = ({ uc, className = '' }) => {
    const r = rotuloCancelamentoUc(uc);
    if (!r) return null;
    return (
        <span title={r.explicacao}
            className={`text-[11px] whitespace-nowrap cursor-help ${r.texto === 'data não registrada'
                ? 'text-gray-400 dark:text-slate-500 italic'
                : 'text-gray-600 dark:text-slate-300'} ${className}`}>
            {r.texto}{r.estimada ? <span className="text-gray-400 dark:text-slate-500"> (estimada)</span> : null}
        </span>
    );
};

export default DataCancelamentoUc;
